import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import './home.styles.scss';

import LinkCards from '../link-cards/link-cards.component';
import MarkdownToJsx from '../markdown-to-jsx/markdown-to-jsx.component';

import { TabInfoContext } from '../../contexts/tab-info.context';
import { GlobalContext } from '../../contexts/global.context';

export default function Home() {
  const { tabInformation } = useContext(TabInfoContext);
  const { selectedSubTab, handleUpdate } = useContext(GlobalContext);
  let navigate = useNavigate();

  const homeInfo = tabInformation.find(ti => ti.name === 'Home');
  const cardGroupName = selectedSubTab === 'none' ? 'Home' : selectedSubTab;
  const mainCardInfoList = homeInfo ? homeInfo.linkCards['Home'] : null; 
  const secondaryCardInfoList = (homeInfo && cardGroupName !== 'Home') ? homeInfo.linkCards[cardGroupName] : null;

  function handleClick(cardName, linkToObj) {
    if (linkToObj.isInternal === false) {
      window.open(linkToObj.src,'_blank');
    } else if (linkToObj.isTool) {
      const newTab = linkToObj.isTool[0];
      const newSubTab = linkToObj.isTool[1];
      navigate(`/${newTab.toLowerCase().split(' ').join('-')}/${newSubTab.toLowerCase().split(' ').join('-')}`);
      handleUpdate('nav', { newTab, newSubTab });
    } else {
      const newSubTab = cardName.toLowerCase().split(' ').join('-');
      navigate(`/${newSubTab}`);
      handleUpdate('nav', { newTab: 'Home', newSubTab: newSubTab === '' ? 'none' : cardName });
    }
  }

  if (homeInfo && mainCardInfoList) {
    return (
      <div className='home-container'>
        <div className='text-block'>
          <MarkdownToJsx
            path={`${process.env.PUBLIC_URL}/markdown/home-top.md`}
          />
        </div>
        <hr />
        <div className='home-content-container'>
          <LinkCards selected={selectedSubTab} cardInfoList={mainCardInfoList} handleClick={handleClick} />
          <div className='home-content-main'>
            {secondaryCardInfoList ? (
              <React.Fragment>
                <LinkCards
                  cardInfoList={secondaryCardInfoList}
                  selected={selectedSubTab}
                  isSecondary={true}
                  handleClick={handleClick}
                />
              </React.Fragment>
            ) : (
              <MarkdownToJsx
                path={`${process.env.PUBLIC_URL}/markdown/home-main.md`}
              />
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className='home-container'>
        <h1>No content for this URL</h1>
        <button onClick={() => handleClick('', { isInternal: true, isTool: false })}>Home</button>
      </div>
    );
  }
}